import React, { useState, useEffect } from "react";
import robotImage from "../assets/robot.png";
import "./Dashboard.css";

const Dashboard = ({ companies, fetchCompanies, goBack, bgColor }) => {
  const [loading, setLoading] = useState(false);

  const handleReload = async () => {
    if (!fetchCompanies) return;
    setLoading(true);
    try {
      await fetchCompanies();
    } catch (err) {
      console.error("Error reloading companies:", err);
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (value) => {
    if (value === null || value === undefined) return "N/A";
    if (value >= 1_000_000_000_000) return (value / 1_000_000_000_000).toFixed(2) + "T";
    if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(2) + "B";
    if (value >= 1_000_000) return (value / 1_000_000).toFixed(2) + "M";
    return value.toLocaleString();
  };

  useEffect(() => {
    if (companies && companies.length > 0) {
      setLoading(false);
    }
  }, [companies]);

  const isDarkMode = bgColor === "#1e1e1e";
  const textColor = isDarkMode ? "#fff" : "#000";
  const cardBgColor = isDarkMode ? "#2c2c2c" : "#fff";

  return (
    <div className="dashboard-wrapper" style={{ backgroundColor: bgColor }}>
      {/* Botones Reload y Menu */}
      <div className="menu-container">
        <button className="reload-button" onClick={handleReload}>
          Reload
        </button>
        <button className="menu-button" onClick={goBack}>
          Menu
        </button>
      </div>

      <div className="dashboard-container">
        {/* Robot */}
        <div className="robot-section">
          <img src={robotImage} alt="Robot" className="robot-image" />
          <p style={{ color: textColor, fontWeight: "bold", marginTop: "10px" }}>
            STOCK EXCHANGE
          </p>

          {loading && (
            <div className="loading-container">
              <span>🤖 Thinking...</span>
              <div className="dots">
                <span className="dot"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
            </div>
          )}
        </div>

        {/* Cards */}
        <div className="cards-container">
          {!loading &&
            companies?.map((c, idx) => (
              <div
                key={idx}
                className="card"
                style={{ color: textColor, backgroundColor: cardBgColor }}
              >
                <h3>{c.name}</h3>

                <p><strong>Ticker:</strong> {c.ticker}</p>

                <p>
                  <strong>Market Cap:</strong> ${formatMoney(c.marketCap)}
                </p>

                <p>
                  <strong>Stock Price:</strong>{" "}
                  {c.stockPrice !== null && c.stockPrice !== undefined
                    ? `$${c.stockPrice.toFixed(2)}`
                    : "N/A"}
                </p>

                <p>
                  <strong>Revenue:</strong> ${formatMoney(c.revenue)}
                </p>

                <p>
                  <strong>Profit:</strong> ${formatMoney(c.profit)}
                </p>

                <p>
                  <strong>52W Range:</strong> {c.fiftyTwoWeekRange || "N/A"}
                </p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
